export const laborRecordTypeCatalog: Record<string, { urlCheck: string }> = {
  CNDT: {
    urlCheck:
      'https://cndt-certidao.tst.jus.br/inicio.faces;jsessionid=Gn99NZ4C_18u7EQz0iHxjAVIgWTleRZHfZVaJt4M.cndt-certidao-25-8qqs2'
  },
  FGTS: {
    urlCheck: 'https://consulta-crf.caixa.gov.br/consultacrf/pages/consultaEmpregador.jsf'
  }
}
